import { Button, Grid } from "@material-ui/core";
import React, { useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import REACT_APP from "../../environment";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const UpdateTimeOff = (props) => {
    const { t } = useTranslation();
    const { getData, data } = props;
    const closeRef = useRef(null);
    const [value, setValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const Submit = async (item) => {
        let set = data.annual_vacation !== null ? "put" : "post";
        item.id = data.id;
        setLoading(true);
        console.log(item);
        await axios({
            method: set,
            data: item,
            headers: { Authorization: sessionStorage.getItem("token") },
            url: `${REACT_APP.URL}/api/hrp/v1/timeoff/employee/balance`,
        })
            .then((res) => {
                setLoading(false);
                getData();
                closeRef.current.click();
                toast.success(t("Success"));
            })
            .catch((err) => {
                setLoading(false);
                toast.error(t("Something went wrong"));
            });
    };

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setValue(data);
            setLoading(false);
        });
    }, [data]);

    return (
        <div className="container">
            <div className="modal fade" id="edit_toff" tabIndex="-1" aria-labelledby="edit_toffLabel" aria-hidden="true">
                {loading ? <div className="hrp-overlay"></div> : null}
                <div className="modal-dialog modal-md modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body p-3">
                            <div className="flex-column container">
                                <form onSubmit={handleSubmit(Submit)} className="container py-2 example row g-3">
                                    <Grid className="modal-header py-2 px-0">
                                        <h5>{data.annual_vacation !== null ? t("Update time off") : t("Set time off")}</h5>
                                    </Grid>
                                    <Grid container direction="column" spacing={2}>
                                        <Grid item container spacing={3} xs={12} sm="auto" className="pt-4 mt-0">
                                            <Grid item xs={12} sm={12} className="pt-0">
                                                <label for="" className="form-label">
                                                    {t("Annual Vacation")}
                                                </label>
                                                <input
                                                    type="number"
                                                    defaultValue={value?.annual_vacation ? value?.annual_vacation : ""}
                                                    className={`form-control ${errors.hour && "is-invalid"}`}
                                                    disabled={loading}
                                                    {...register("hour", { required: true })}
                                                />
                                            </Grid>

                                            <Grid className="modal-footer mt-4 pt-3" item xs={12} sm={12}>
                                                <Button
                                                    color={loading ? "inherit" : "secondary"}
                                                    className="me-3"
                                                    variant="contained"
                                                    data-bs-dismiss="modal"
                                                    ref={closeRef}
                                                    onClick={() => reset()}
                                                >
                                                    {t("Cancel")}
                                                </Button>

                                                <Button
                                                    className="float-end"
                                                    disabled={loading}
                                                    color="primary"
                                                    type="submit"
                                                    variant="contained"
                                                    startIcon={loading && <CircularProgress size="0.9rem" />}
                                                >
                                                    {loading ? t("Saving") : t("Save")}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default React.memo(UpdateTimeOff);
